import { useQuery } from '@tanstack/react-query';
import type { TransportationTaxesDetailsDto } from '../../../models/taxes/transportation/transportation-taxes-details.dto';
import type { TransportationTaxesPaginatedList } from '../../../models/taxes/transportation/transportation-taxes-paginated-list.model';
import apiRequest from '../../../services/apiWrapper';
import { createPaginatedQueryKeys } from '../../../services/createPaginatedQueryKeys';
import { TRANSPORT_PAYMENTS } from '../../../utils/constants/urlConstants';

async function fetchTransportationTaxes(searchParams: URLSearchParams) {
  const response = await apiRequest.get<
    TransportationTaxesPaginatedList<TransportationTaxesDetailsDto>
  >(`${TRANSPORT_PAYMENTS}/students?${searchParams.toString()}`);

  return response.data;
}

export function createQueryKey(searchParams: URLSearchParams) {
  return {
    fromDate: searchParams.get('fromDate'),
    toDate: searchParams.get('toDate'),
    month: searchParams.get('month'),
    year: searchParams.get('year'),
    name: searchParams.get('name'),
    isPaid: searchParams.get('isPaid'),
    paymentMethodType: searchParams.get('paymentMethodType'),
    scholarshipType: searchParams.get('scholarshipType'),
    ...createPaginatedQueryKeys(searchParams),
  };
}

export function usePaginatedTransportationTaxes(searchParams: URLSearchParams) {
  return useQuery({
    queryKey: ['transportation-taxes', createQueryKey(searchParams)],
    queryFn: () => fetchTransportationTaxes(searchParams),
    throwOnError: false,
  });
}
